import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { State, Action, Getter, Mutation } from 'vuex-class';

import User from '@/../bower_components/teknisavuecomponents/assets/interfaces/User';
import ToolbarAction from '@/../bower_components/teknisavuecomponents/assets/interfaces/ToolbarAction';
import DateUtil from '@/../bower_components/teknisavuecomponents/assets/utils/DateUtil';
import Util from '@/../bower_components/teknisavuecomponents/assets/utils/Util';
import store from '@/store/store';
import EditableTable from '@/../bower_components/teknisavuecomponents/components/grids/EditableTable.vue';
import NovaAssinaturaPopup from '@/components/documentos/NovaAssinaturaPopup/NovaAssinaturaPopup.vue';
import AprovaReprovaAssinaturaPopup from '@/components/documentos/AprovaReprovaAssinaturaPopup/AprovaReprovaAssinaturaPopup.vue';
import TkVisualizer from '@/../bower_components/teknisavuecomponents/components/document/TkVisualizer/TkVisualizer.vue';
import FileUtils from '@/../bower_components/teknisavuecomponents/assets/utils/FileUtils';
import DocumentosController from '@/assets/ts/controller/DocumentosController';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { ControleAcessoWrapper } from '@/assets/ts/controller/ControleAcessoController';

@Component({
  name: 'Assinatura',
  components: {
    EditableTable,
    NovaAssinaturaPopup,
    AprovaReprovaAssinaturaPopup,
    TkVisualizer
  },
})
class Assinatura extends Vue {
  // #region [ STORE ]
  private get user(): User {
    return this.$store.getters.user;
  }

  @Mutation('changeCurrentView')
  private changeCurrentView: (viewName: string) => void;
  // #endregion

  // #region [ DATA ]
  private readonly PAGE_NAME = 'Assinatura';

  private loading = false;
  private tableRows: any[] = [];

  private filterStatus: string[] = [];
  private filterAprovStatus = false;

  private statusSoli = {
    aprovada: 'A',
    reprovada: 'R',
    pendente: 'P'
  };

  private novaAssinaturaPopup = {
    show: false
  };

  private aprovaReprovaAssinaturaPopup = {
    show: false,
    row: {},
    isAprova: true
  };

  private visualizerPopup = {
    show: false,
    base64: '',
    mimeType: '',
  };

  private visualizer = {
    show: false,
    base64: '',
    mimeType: '',
    fileName: '',
  };

  private toolbarActions: ToolbarAction[] = [
    {
      name: 'reload',
      label: 'Atualizar',
      icon: 'mdi-refresh',
      onClick: this.reload,
    },
  ];

  private view = {
    title: 'Assinatura Digital',
    popUpTitle: 'Assinatura Digital',
  };

  private grid = {
    name: this.view.popUpTitle,
    messages: {
      loadingText: 'Carregando Documentos...',
      noDataText: 'Nenhum Documento para Assinatura Encontrado.',
    },
    triggers: {
      reload: 0,
    },
    dataSource: {
      route: 'getDocumentosPendentesAssinaturaGestor',
      filters: {
        NRORG: store.getters.user.nrorg,
        NRVINCULOM: store.getters.user.nrvinculom,
        NRPERIODOAPURACAO: store.getters.periodoDemonstrativoAtual.NRPERIODOAPURACAO
      },
    },
    toolbarActions: [
      'reload',
      {
        name: 'addSolicitacao',
        label: 'Nova Assinatura',
        showLabel: true,
        icon: 'mdi-plus-circle',
        onClick: ControleAcessoWrapper.criar(this.openNovaAssinatura),
      },
    ],
    columns: [
      {
        text: 'Nr. Int. Assinatura',
        value: 'NRINTELETRDIGIT',
        type: 'number',
        cols: 3,
        tag: 'v-text-field',
        required: false,
        showOnList: true,
        showOnForm: false,
      },
      {
        value: 'NMVINCULOM',
        text: 'Vínculo',
        cols: 9,
        tag: 'TkSelect',
        autocomplete: true,
        valueField: 'NRVINCULOM',
        descriptionField: 'NMVINCULOM',
        required: true,
        reloadOnClick: true,
      },
      {
        text: 'Nr. Documento',
        value: 'NRANEXO',
        type: 'number',
        cols: 3,
        tag: 'v-text-field',
        required: false,
        showOnList: false,
        showOnForm: false,
      },
      {
        text: 'Nome Documento',
        value: 'NMDOCUMENTO',
        type: 'text',
        cols: 3,
        tag: 'v-text-field',
        required: false,
        showOnList: false,
        showOnForm: false,
      },
      {
        text: 'Data de Geração',
        value: 'DTINCLUSAO',
        type: 'text',
        cols: 3,
        tag: 'TkDate',
        defaultValue: this.getCurrentDate(),
        required: true,
        showOnForm: true,
      },
      {
        text: 'Status',
        value: 'IDACEITESTATUS',
        readonly: true,
        type: 'text',
        cols: 3,
      }
    ],
    actions: [
      {
        label: 'Ver Arquivo',
        value: 'viewFile',
        icon: 'mdi-file-eye',
        onClick: this.viewFile,
        mode: 'view',
      },
      {
        label: 'Aprovar',
        value: 'aprovar',
        icon: 'mdi-check',
        onClick: ControleAcessoWrapper.atualizar(this.aprovarAssinatura),
        mode: 'view',
        condition: this.visibleConditionApproveActions
      },
      {
        label: 'Reprovar',
        value: 'reprovar',
        icon: 'mdi-close',
        onClick: ControleAcessoWrapper.atualizar(this.reprovarAssinatura),
        mode: 'view',
        condition: this.visibleConditionApproveActions
      },
    ],
  };

  private avaliacaoPopup = {
    show: false,
    avaliacao: null,
  };

  
  private get rowFilters() {
    return [this.filterRows];
  }

  private get 'isFilterAprovadasActive'() {
    return this.filterStatus.includes(this.statusSoli.aprovada);
  }

  private get isFilterPendentesActive() {
    return this.filterStatus.includes(this.statusSoli.pendente);
  }

  private get isFilterReprovadasActive() {
    return this.filterStatus.includes(this.statusSoli.reprovada);
  }


  private get noFilterActive() {
    return !this.filterAprovStatus &&
      !this.isFilterAprovadasActive &&
      !this.isFilterPendentesActive &&
      !this.isFilterReprovadasActive
  }
  // #endregion

  // #region [ COMPUTED ]
  //
  // #endregion

  // #region [ LIFECYCLE ]
  private created() {
    this.changeCurrentView(this.PAGE_NAME);

    this.reload();
  }
  // #endregion

  //#region [ METHODS ]
  private async reload() {
    this.reloadGridData();
  }

  private tableAfterReload(rows: any[]): void {
    this.tableRows = rows;
  }

  private openNovaAssinatura() {
    this.novaAssinaturaPopup.show = true;
  }

  private async aprovarAssinatura(row: any) {

    this.aprovaReprovaAssinaturaPopup.isAprova = true;
    this.aprovaReprovaAssinaturaPopup.row = row;
    this.aprovaReprovaAssinaturaPopup.show = true;
  }

  private async reprovarAssinatura(row: any) {

    this.aprovaReprovaAssinaturaPopup.isAprova = false;
    this.aprovaReprovaAssinaturaPopup.row = row;
    this.aprovaReprovaAssinaturaPopup.show = true;
  }

  private visibleConditionApproveActions(row: any) {
    if(row.IDACEITEVINCULO === 'P') {
      return false;
    }

    if(row.IDACEITEVINCULO === 'R' || row.IDACEITEGESTOR === 'R' || row.IDACEITEGESTOR === 'A') {
      return false;
    }

    if(row.IDACEITEVINCULO === 'A' && row.IDACEITEGESTOR === 'P' && store.getters.user.nrvinculom === row.NRVINCULOM) {
      return false;
    }
    return true;
  }

  private async viewFile(row: any) {
    const nrIntegracaoDigital: string = row.NRINTELETRDIGIT;
    const nrVinculo = row.NRVINCULOM;
    const nrParcNegocio = row.NRPARCNEGOCIO;

    this.loading = true;

    try {

      const fileData = await DocumentosController.getIntegracaoDigitalFile(nrIntegracaoDigital, nrParcNegocio);
      const { base64, type } = fileData;

      const fullBase64 = FileUtils.getFullBase64(
        base64, type
      );

      const fileName = `Relatório${nrVinculo}_${nrIntegracaoDigital}`;

      this.visualizer.show = true;
      this.visualizer.base64 = fullBase64;
      this.visualizer.mimeType = type;
      this.visualizer.fileName = fileName;
    } finally {
      this.loading = false;
    }
  }


  private reloadGridData() {
    return this.grid.triggers.reload++;
  }

  private afterSave() {
    this.reloadGridData();
  }

    private filterAprovadas() {
    this.toggleStatusFilter(this.statusSoli.aprovada) ;
  }


  private filterReprovadas() {
    this.toggleStatusFilter(this.statusSoli.reprovada);
  }

  private toggleFilterAprovStatus() {
    this.filterAprovStatus = !this.filterAprovStatus;
  }

  private toggleStatusFilter(status: string) {
    if (!this.filterStatus.includes(status)) {
      this.filterStatus.push(status);
      return;
    }

    const itemIndex = this.filterStatus.indexOf(status);
    if (itemIndex !== -1) {
      this.filterStatus.splice(itemIndex, 1);
    }
  }

  private filterRows(row) {
    return this.filterSoliByAprovStatus(row) || this.filterSoliByStatus(row) || this.noFilterActive;
  }

  private filterSoliByStatus(row: any) {
    if (Util.isEmptyOrBlank(row) || this.filterStatus.length < 1) {
      return false;
    }
    const status = row.IDACEITEVINCULO == 'R' || row.IDACEITEGESTOR === 'R' ? 'R' : row.IDACEITEVINCULO == 'A' && row.IDACEITEGESTOR === 'A' ? 'A' : 'P';

    return this.filterStatus.includes(status);
  }

  private filterSoliByAprovStatus(row: any) {
    if (Util.isEmptyOrBlank(row) || !this.filterAprovStatus) {
      return false;
    }
    return this.visibleConditionApproveActions(row);
  }

  private getCurrentDate(): string {
    const date = new Date();
    const dateString = format(date, 'dd/MM/yyyy HH:mm:ss', { locale: ptBR });

    return dateString;
  }

  //#endregion
}

export default Assinatura;
